import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL; // Use environment variable for API base URL

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    axios.post(`${API}/api/visit`, { path: location.pathname })
      .catch(() => {});   // fail silently
  }, [location]);
}